<template>
  <div>
    <div :class="`row main ${errorClass}`">
      <div class="icon-wrapper flex-row align-self-stretch">
        <i :class="'icon ' + setIcon(icon)" />
      </div>
      <div class="flex-row center">
        <div class="d-flex middle">
          <div class="title">
            <span>{{ title }}</span>
          </div>
        </div>
        <div class="d-flex middle">
          <div :class="`round ${setStatusColor(status)}`">
            <span>
              {{ status }}
            </span>
          </div>
        </div>
      </div>

      <div class="col button-container">
        <div class="link">
          <ActionButton
            variant="success"
            i="fas fa-file-import"
            @click="navigate(linkTo)"
          >
            Entrar
          </ActionButton>
        </div>
      </div>
    </div>
    <Error
      v-for="error in errors"
      :key="error.id"
      variant="no-border"
      :message="error.name"
    />
  </div>
</template>

<script>
import Error from '@/components/common/Error';
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'CustomStatusLink',
  meta: {
    description: 'Componente común de enlace de estado personalizado.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
    ActionButton,
  },
  props: {
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Indica un icono para el componente',
        example: 'fas fa-file-import',
      },
    },
    title: {
      type: String,
      default: '',
      meta: {
        description: 'Establece un encabezado para el componente',
        example: 'Texto requerido',
      },
    },
    status: {
      type: String,
      default: '',
      meta: {
        description: 'Estado del archivo',
        example: 'Texto requerido',
      },
    },
    linkTo: {
      type: String,
      default: '',
      meta: {
        description: 'Indica la ruta del enlace',
        example: 'Texto requerido',
      },
    },
    params: {
      type: Object,
      default: () => undefined,
      meta: {
        description: 'Parametros a utilizar en la ruta',
        example: "['Inicio', 'Estudiante', 'Cuestionario de Intervención']",
      },
    },
    useLinkName: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Indica si se utilizara el link name',
        example: 'true / false',
      },
    },
    errors: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Estado error',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    useLinkEvent: {
      type: Boolean,
      default: () => true,
      meta: {
        description: 'Indica si se utilizara el evento del link',
        example: 'true / false',
      },
    },
  },
  computed: {
    errorClass() {
      return this.errors.length > 0 ? 'bg-error' : '';
    },
  },
  methods: {
    setIcon(icon) {
      let currentIcon;
      switch (icon) {
        case 'chat':
          currentIcon = 'fas fa-comment-lines';
          break;
        case 'comment':
          currentIcon = 'fas fa-comment';
          break;
        default:
          currentIcon = 'fas fa-comment-lines';
          break;
      }
      return currentIcon;
    },
    setStatusColor(status) {
      let statusColor;
      switch (status) {
        case 'Pendiente':
          statusColor = 'pending';
          break;
        case 'Completado':
          statusColor = 'complete';
          break;
        default:
          statusColor = 'undefined';
      }
      return statusColor;
    },
    navigate(linkTo) {
      if (!this.useLinkEvent) {
        this.$emit('enter');
        return;
      }

      let route = {};
      if (this.useLinkName) {
        route = { name: linkTo, params: this.params };
      } else {
        route = { path: linkTo, params: this.params };
      }
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.main {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  width: 100%;
  padding: 0;
}
.center {
  display: flex;
  float: left;
  padding-top: 10px;
  width: 80%;
  flex-wrap: nowrap;
  align-content: stretch;
}
.icon-wrapper {
  width: 50px;
  background-color: #ff7058;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.icon-wrapper > i {
  font-size: 1.8em;
  color: #fff;
  padding: 15px 5px 5px 10px;
  text-align: center;
}
.title {
  padding-top: 7px;
  padding-left: 40px;
}
.d-flex.middle {
  width: 100%;
  align-self: stretch;
}
.round {
  border-radius: 20px;
  text-align: center;
  height: 40px;
  padding: 7px;
  width: auto;
  padding-left: 30px;
  padding-right: 30px;
}
.round > span {
  font-size: 16px;
}
.pending {
  background: #f8ea80;
}
.complete {
  background: #a3e5b3;
}
.undefined {
  background: #d5b89a;
}
.bg-error {
  background-color: #ffebeb;
  border: 1px solid #ff5b5c;
}
.link {
  float: right;
}
.link span {
  color: #fff;
  padding-left: 10px;
}

.button-container {
  padding: 10px;
}

.btn-green.btn-success:hover {
  background-color: #2b9d71;
}

@media (max-width: 600px) {
  .center {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
  }
  .title {
    text-align: center;
  }
  .round {
    display: flex;
    align-self: center;
  }
  .button-container {
    display: flex;
    align-self: center;
  }
}
</style>
